import nofunds from '../../../Assets/nofunds.png';
import { Box, Typography } from '@mui/material';
import { useStyles } from '../styles';

const NoFunds: React.FunctionComponent<any> = ({ header, subHeader }) => {
  const classes = useStyles();
  return (
    <div className="h-100 w-100 d-flex flex-column justify-content-center align-items-center">
      <div className="d-flex align-items-center flex-column gap-3">
        <Box component={'img'} src={nofunds} height={'72px'} width={'72px'} sx={{ objectFit: 'cover' }} />
        <div className="d-flex flex-column gap-2">
          <Typography className={classes.noFundsHeader} fontWeight={'600'}>
            {header}
          </Typography>
          <Typography className={classes.noFundsHeader} fontWeight={'400'}>
            {subHeader}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default NoFunds;
